import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/zip.js
// module id = 531
// module chunks = 0